import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-policychange-common-react';

import PUPLocationsPage from './pages/Locations/LocationsPage';
import PUPYourPoliciesPage from './pages/YourPolicies/YourPoliciesPage';
import PUPAdditionalInfoToPurchasePagePolChange from './pages/AdditionalInfoToPurchase/AdditionalInfoToPurchasePagePolChange';
import PUPAddressPagePolChange from '../ml-capability-policychange-common-react/pages/Address/AddressPagePolChange';
import PUPBillingDetailsPagePolChange from '../ml-capability-policychange-common-react/pages/BillingDetails/BillingDetailsPagePolChange';
import PUPAffiliationPagePolChange from '../ml-capability-policychange-common-react/pages/Affiliation/AffiliationPagePolChange';
import PUPBusinessActivityPagePolChange from '../ml-capability-policychange-common-react/pages/BusinessActivity/BusinessActivityPagePolChange';
import PUPWatercraftPagePolChange from '../ml-capability-policychange-common-react/pages/Watercraft/WatercraftPagePolChange';
import PUPWatercraftOperatorPagePolChange from '../ml-capability-policychange-common-react/pages/WatercraftOperator/WatercraftOperatorPagePolChange';
import PUPVehicleOperatorPagePolChange from '../ml-capability-policychange-common-react/pages/VehicleOperator/VehicleOperatorPagePolChange';
import PUPYourPoliciesPagePolChange from '../ml-capability-policychange-common-react/pages/YourPolicies/YourPoliciesPagePolChange';
import AdditionalPolicyInfoPolChange from '../ml-capability-policychange-common-react/pages/AdditionalPolicyInfo/AdditionalPolicyInfoPolChange';
import PUPLocationPagePolChange from '../ml-capability-policychange-common-react/pages/Location/LocationPagePolChange';
import PUPVehiclesPagePolChange from '../ml-capability-policychange-common-react/pages/Vehicles/PUPVehiclesPagePolChange';
import PUPConfirmationPolChange from '../ml-capability-policychange-common-react/pages/Confirmation/ConfirmationPolChange';
import PUPDisclosurePagePolChange from '../ml-capability-policychange-common-react/pages/Disclosures/DisclosurePagePolChange';

setComponentMapOverrides(
    {
        PUPLocationsPage: { component: 'PUPLocationsPage' },
        PUPYourPoliciesPage: { component: 'PUPYourPoliciesPage' },
        PUPAddressPagePolChange: { component: 'PUPAddressPagePolChange' },
        PUPAffiliationPagePolChange: { component: 'PUPAffiliationPagePolChange'},
        PUPBillingDetailsPagePolChange: { component: 'PUPBillingDetailsPagePolChange'},
        PUPBusinessActivityPagePolChange: { component: 'PUPBusinessActivityPagePolChange'},
        PUPYourPoliciesPagePolChange: { component: 'PUPYourPoliciesPagePolChange'},
        AdditionalPolicyInfoPolChange: { component: 'AdditionalPolicyInfoPolChange' },
        PUPLocationPagePolChange: { component: 'PUPLocationPagePolChange'},
        PUPWatercraftPagePolChange: { component: 'PUPWatercraftPagePolChange'},
        PUPWatercraftOperatorPagePolChange: { component: 'PUPWatercraftOperatorPagePolChange'},
        PUPVehicleOperatorPagePolChange: { component: 'PUPVehicleOperatorPagePolChange'},
        PUPVehiclesPagePolChange: { component: 'PUPVehiclesPagePolChange'},
        PUPConfirmationPolChange: { component: 'PUPConfirmationPolChange' },
        PUPAdditionalInfoToPurchasePagePolChange: { component: 'PUPAdditionalInfoToPurchasePagePolChange' },
        PUPDisclosurePagePolChange: { component: 'PUPDisclosurePagePolChange' }
    },
    {
        PUPLocationsPage,
        PUPYourPoliciesPage,
        PUPAddressPagePolChange,
        PUPAffiliationPagePolChange,
        PUPBillingDetailsPagePolChange,
        PUPBusinessActivityPagePolChange,
        PUPYourPoliciesPagePolChange,
        AdditionalPolicyInfoPolChange,
        PUPLocationPagePolChange,
        PUPWatercraftPagePolChange,
        PUPWatercraftOperatorPagePolChange,
        PUPVehicleOperatorPagePolChange,
        PUPVehiclesPagePolChange,
        PUPConfirmationPolChange,
        PUPAdditionalInfoToPurchasePagePolChange,
        PUPDisclosurePagePolChange
    }
);
// eslint-disable-next-line import/prefer-default-export
export { default as PUPPolicyChangeWizard } from './PUPPolicyChangeWizard';
export { default as PUPPolicyChangeMessages } from './PUPPolicyChange.messages';
